import { EventEmitter, Input, Output, Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  CELLPHONE_MASK, LANDLINE_MASK, VALIDA_CELULAR_FIXO, PORTUGAL_PATTERN_PHONE, USA_PATTERN_PHONE
} from 'src/app/core/constants/consts';
import { flagOptions } from 'src/app/core/constants/flag-Input-const';
import { FlagListModel } from '../flag-input/flag-input.model';

@Component({
  selector: 'app-input-dropdown-country-prefix-phone',
  templateUrl: './input-dropdown-country-prefix-phone.component.html',
  styleUrls: ['./input-dropdown-country-prefix-phone.component.scss']
})
export class InputDropdownCountryPrefixPhoneComponent implements OnInit {

  @Input() label: string;
  @Input() control = new FormControl();
  @Input() fieldName: string;
  @Input() hint: string;
  @Input() showIcon = true;
  @Output() blured = new EventEmitter();
  @Output() inputed = new EventEmitter();
  @Output() keyupped = new EventEmitter();
  @Input() controlCountry = new FormControl();
  @Input() required: boolean;

  flagOptions = flagOptions;
  selectedOption: FlagListModel;
  arrowOpen = false;
  phoneLenght: number;
  phoneMask: string;

  ngOnInit() {
    this.initSelectOption();
    this.pickValidators();
    this.phoneLenght = this.control?.value?.length || 0;
    this.onPhoneChanged(new KeyboardEvent(''), 11);
  }

  initSelectOption(): void {
    this.selectedOption = this.flagOptions.find(
      item => item.prefix === this.controlCountry.value
    );
    if (!this.selectedOption) {
      this.selectedOption = this.flagOptions[0];
    }
  }

  selectOption(prefixCountry) {
    this.selectedOption =  this.flagOptions.find((option) => option.prefix === prefixCountry);
    if (!this.selectedOption) {
      return;
    }
    this.pickValidators();
    this.phoneMask = this.selectedOption.mask;
    this.controlCountry.setValue(this.selectedOption.prefix);
    this.control.setValue('');
    this.control.markAsTouched();
  }

  captureClickEvent() {
    this.arrowOpen = true;
  }

  checkIfFieldHasNotValueAndMarkAsTouched() {
    this.arrowOpen = false;
    this.controlCountry.markAsTouched();
  }

  pickValidators(): void {
    const validators = [];
    if (this.required) {
      validators.push(Validators.required);
    }
    if (this.selectedOption?.prefix === '+55') {
      validators.push(Validators.pattern(VALIDA_CELULAR_FIXO));
    } else if (this.selectedOption?.prefix === '+351') {
      validators.push(Validators.pattern(PORTUGAL_PATTERN_PHONE));
    } else if (this.selectedOption?.prefix === '+1') {
      validators.push(Validators.pattern(USA_PATTERN_PHONE));
    }
    this.control.setValidators(validators);
  }

  onPhoneChanged(e: KeyboardEvent, length = 10): void {
    // tslint:disable: deprecation
    if (this.selectedOption?.prefix === '+55') {
      const phoneValue = this.control.value;
      // e.keyCode === 8 = backspace
      if (this.phoneLenght < length || e?.keyCode === 8) {
        this.phoneMask = LANDLINE_MASK;
      } else if (this.phoneLenght === length) {
        this.phoneMask = CELLPHONE_MASK;
        this.control.setValue(phoneValue + e.key);
      }
      this.phoneLenght = this.control?.value?.length || 0;
    } else {
      this.phoneMask = this.selectedOption.mask;
    }
  }

}
